import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import Card from "../components/Card";
import Feature from "../components/Feature";
import Tags from "../components/Tags";
import Arrow from "../../src/assets/svg/arrowRight.svg";
import NavHeader from "../components/NavHeader";
import StoreInfo from "../components/StoreInfo";
import { useEffect, useState } from "react";
import functionsStore from "../functions/stores/functionsStore";
import { toast } from "react-toastify";
import { Vehicle, vehicleInitialize } from "../data/models";
import CarouselsContainer from "../components/CarouselsContainer";
import ButtonExpandContent from "../components/ButtonExpandContent";
import ExpandContent from "../components/ExpandContent";
import { Carousel as NewCarousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ImageInfo from "../components/ImageInfo";
import PromoContent from "../components/PromoContent";
import { safeHref, sortAndGroupVehicles } from "../functions/utils";

const CarPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [car, setCar] = useState<Vehicle>(vehicleInitialize);
  const [tags, setTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState<boolean>(false);
  const [open2, setOpen2] = useState<boolean>(false);
  const [options, setOptions] = useState<string[]>([]);

  const priceListUrl = safeHref(car?.vehicle?.price_list);

  const renderArrowPrev = (
    onClickHandler: () => void,
    hasPrev: boolean,
    label: string
  ) =>
    hasPrev && (
      <button
        type="button"
        onClick={onClickHandler}
        title={label}
        className="custom-control-arrow left"
      >
        ❮ {/* Replace with your custom arrow or icon */}
      </button>
    );

  const renderArrowNext = (
    onClickHandler: () => void,
    hasNext: boolean,
    label: string
  ) =>
    hasNext && (
      <button
        type="button"
        onClick={onClickHandler}
        title={label}
        className="custom-control-arrow right"
      >
        ❯ {/* Replace with your custom arrow or icon */}
      </button>
    );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const fetchedData = await functionsStore.getCarDataById(id);

        if (!fetchedData) {
          toast.error("Vozilo nije pronađeno.");
          navigate("/404");
          return;
        }

        if (fetchedData) {
          setCar({
            ...fetchedData,
            vehicle: {
              ...fetchedData.vehicle,
              brand:
                fetchedData.vehicle.brand.toUpperCase() === "CITROEN"
                  ? "CITROËN"
                  : fetchedData.vehicle.brand,
            },
            dealer_vehicles: fetchedData.dealer_vehicles
              .filter(
                (car) =>
                  car.brand.toUpperCase() === "CITROEN" ||
                  car.brand.toUpperCase() === "CITROËN"
              ) // Filter CITROEN
              .map((car) => ({
                ...car,
                brand:
                  car.brand.toUpperCase() === "CITROEN" ? "CITROËN" : car.brand,
              })),
            similar_vehicles: fetchedData.similar_vehicles
              .filter(
                (car) =>
                  car.brand.toUpperCase() === "CITROEN" ||
                  car.brand.toUpperCase() === "CITROËN"
              ) // Filter CITROEN
              .map((car) => ({
                ...car,
                brand:
                  car.brand.toUpperCase() === "CITROEN" ? "CITROËN" : car.brand,
              })),
          });

          //console.log(fetchedData);
          setTags([
            fetchedData.vehicle.type_hr,
            fetchedData.vehicle.color_f,
            fetchedData.vehicle.color_design,
            fetchedData.vehicle.trim_design,
          ]);

          //prepare options string for display
          if (fetchedData.vehicle.options?.length > 0) {
            const splitOptions = fetchedData.vehicle.options
              .split("|")
              .map((option) => option.trim());

            setOptions(splitOptions);
          }
        } else {
          toast.error("Nema dostupnih podataka.");
        }
      } catch (err) {
        toast.error("Došlo je do pogreške pri dohvaćanju podataka.");
        //console.error("Error fetching car data:", err);
        navigate("/404");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  return (
    <div className="flex flex-col min-h-screen gap-6 px-4 py-8 sm:px-6">
      <NavHeader px="">
        <div className="flex items-center max-w-full gap-2 overflow-x-auto sm:overflow-visible whitespace-nowrap">
          <h4
            onClick={() => navigate("/")}
            className="text-lg font-medium cursor-pointer sm:text-xl text-gray-dark whitespace-nowrap"
          >
            Trenutno dostupno
          </h4>
          <img src={Arrow} alt="Arrow"></img>
          <h4 className="text-lg font-medium sm:text-xl text-gray-extra-dark whitespace-nowrap">
            {car.vehicle.brand}&nbsp;{car.vehicle.family}
          </h4>
        </div>
        <Link
          to={`/request/${id}`}
          state={{
            mode: "Zatražite ponudu",
          }}
        >
          <Button
            text={"Zatražite ponudu"}
            variant={"primary"}
            size={"base"}
            className="hidden sm:flex"
          ></Button>
        </Link>
      </NavHeader>

      {loading ? (
        <p className="text-center">Učitavanje podataka...</p>
      ) : (
        <div className="flex flex-col gap-10">
          <Card cardStyle="secondary" gap="gap-6">
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-[22px] font-medium sm:text-2xl text-gray-extra-dark">
                {car.vehicle.brand}&nbsp;{car.vehicle.family}
                {/* {car.vehicle.vehicle_state_hr === "Vozilo u dolasku" && (
                  <span className="items-center block px-1 py-1 mt-1 mb-1 text-sm border rounded-full md:inline-flex md:justify-center md:mt-0 md:ml-2 size-fit text-primary-blue border-primary-blue">
                    U dolasku
                  </span>
                )} */}
              </h3>
              <Link
                to={`/request/${id}`}
                state={{
                  mode: "Zatražite ponudu",
                }}
              >
                <Button
                  text={"Zatražite ponudu"}
                  variant={"primary"}
                  size={"base"}
                  className="sm:hidden text-[15px]"
                ></Button>
              </Link>
              <Tags tags={tags} className="justify-end hidden sm:flex"></Tags>
            </div>

            <div className="flex flex-col w-full gap-6 lg:flex-row">
              <div className="carousel-container">
                <div className="relative">
                  {car.vehicle.akcija_text2 && (
                    <div className="absolute z-50 font-bold text-[11px] py-1 px-1.5 top-2 left-2 rounded-full text-white bg-primary-red">
                      Akcija
                    </div>
                  )}
                  {/* <Image image={car.vehicle.link} size="lg"></Image> */}

                  <NewCarousel
                    showThumbs={true}
                    autoPlay
                    infiniteLoop
                    renderArrowPrev={renderArrowPrev}
                    renderArrowNext={renderArrowNext}
                  >
                    {car.vehicle.link && (
                      <img src={car.vehicle.link} alt="Foto 1" />
                    )}
                    {car.vehicle.foto1 && (
                      <img src={car.vehicle.foto1} alt="Foto 2" />
                    )}
                    {car.vehicle.foto2 && (
                      <img src={car.vehicle.foto2} alt="Foto 3" />
                    )}
                    {car.vehicle.foto3 && (
                      <img src={car.vehicle.foto3} alt="Foto 4" />
                    )}
                    {car.vehicle.foto4 && (
                      <img src={car.vehicle.foto4} alt="Foto 5" />
                    )}
                  </NewCarousel>
                </div>
                <div className="flex flex-col gap-4">
                  <ImageInfo />
                </div>
              </div>

              <div className="flex flex-col gap-6 lg:w-1/2">
                <div className="flex flex-col justify-between gap-6 ">
                  <Tags tags={tags} className="sm:hidden"></Tags>

                  <div className="flex flex-col justify-between gap-6 sm:flex-row ">
                    <div className="flex flex-col gap-3 sm:gap-2">
                      <p className="text-[13px] text-gray-extra-dark opacity-80">
                        {car.vehicle.model_designation}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      {car.vehicle.dealer !== null && (
                        <p className="flex sm:hidden text-base font-medium items-center gap-[5px] opacity-25">
                          {car.vehicle.dealer.name}
                        </p>
                      )}
                      {car.vehicle.mask_price !== "0" &&
                        car.vehicle.mask_price?.length > 0 ? (
                        <div className="flex flex-col text-end">
                          <div className="flex justify-end gap-2">
                            {car.vehicle.mask_price_akcija?.length > 0 ? (
                              <>
                                <p className="flex items-end pb-[3px] text-lg font-medium line-through text-gray-extra-dark text-opacity-80 whitespace-nowrap decoration-primary-red decoration-2">
                                  {Number(
                                    car.vehicle.mask_price
                                  ).toLocaleString("de-DE", {
                                    maximumFractionDigits: 0,
                                  })}{" "}
                                  €
                                </p>
                                <p className="text-[26px] font-medium text-primary-blue whitespace-nowrap">
                                  {Number(
                                    car.vehicle.mask_price_akcija
                                  ).toLocaleString("de-DE", {
                                    maximumFractionDigits: 0,
                                  })}{" "}
                                  €
                                </p>
                              </>
                            ) : (
                              <p className="text-[26px] font-medium text-gray-extra-dark whitespace-nowrap">
                                {Number(car.vehicle.mask_price).toLocaleString(
                                  "de-DE",
                                  {
                                    maximumFractionDigits: 0,
                                  }
                                )}{" "}
                                €
                              </p>
                            )}
                          </div>
                          <p className="text-[11px] text-gray-extra-dark">
                            {car.vehicle.mask_price_note}
                          </p>
                        </div>
                      ) : (
                        <p className="text-base font-bold text-primary-blue whitespace-nowrap">
                          Cijena na upit
                        </p>
                      )}
                    </div>
                  </div>
                  <hr className="w-full border-t-1 border-extra-light" />
                  <div className="flex flex-col gap-4">
                    <Feature
                      title="Glavne značajke"
                      items={[
                        { title: "Gorivo", value: car.vehicle.fuel_hr },
                        { title: "Motor", value: car.vehicle.model_engine },
                        {
                          title: "Mjenjač",
                          value: car.vehicle.transmission_type,
                        },
                        { title: "Boja", value: car.vehicle.color_design },
                        {
                          title: "Unutrašnjost",
                          value: car.vehicle.trim_design,
                        },
                        {
                          title: "Emisija CO2 (WLTP)",
                          value: car.vehicle.co2_hr,
                        },
                        {
                          title: "Prosječna potrošnja (WLTP)",
                          value:
                            car.vehicle.model_engine
                              .slice(0, 3)
                              .toLowerCase() !== "ele"
                              ? car.vehicle.mask_potrosnja
                              : "",
                        },
                      ]}
                      initiallyOpened={true}
                    >
                      <div className="flex items-center gap-3">
                        {priceListUrl && (
                          <a
                            href={priceListUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button
                              text="Razine opreme"
                              variant="ternary"
                            ></Button>
                          </a>
                        )}
                      </div>
                    </Feature>
                    {options?.length > 0 && (
                      <>
                        <hr className="w-full border-t-1 border-extra-light" />

                        <ButtonExpandContent
                          onClick={() => setOpen2((prev) => !prev)}
                          open={open2}
                          title={"Dodatne opcije"}
                        />
                        <ExpandContent open={open2}>
                          <div className="w-full px-4 py-2 gap-[10px] text-[13px] text-gray-extra-dark text-opacity-80">
                            {options.map((option, index) => (
                              <div key={index} className="mb-2">
                                {option}
                              </div>
                            ))}
                          </div>
                        </ExpandContent>
                      </>
                    )}

                    {(car.vehicle.akcija_text1?.length > 0 ||
                      car.vehicle.akcija_text2?.length > 0 ||
                      car.vehicle.akcija_text3?.length > 0) && (
                        <>
                          <hr className="w-full border-t-1 border-extra-light" />

                          <ButtonExpandContent
                            onClick={() => setOpen((prev) => !prev)}
                            open={open}
                            title={"Dodatne pogodnosti"}
                          />
                          <ExpandContent open={open}>
                            <PromoContent
                              text1={car.vehicle.akcija_text2}
                              text2={car.vehicle.akcija_text1}
                              text3={car.vehicle.akcija_text3}
                            />
                          </ExpandContent>
                        </>
                      )}
                  </div>
                </div>
                <hr className="w-full border-t-1 border-extra-light" />

                <div className="flex items-center justify-between gap-6">
                  <div className="flex flex-col w-full gap-3 sm:w-auto sm:flex-row">
                    <Link
                      to={`/request/${id}`}
                      state={{
                        mode: "Zatražite ponudu",
                      }}
                    >
                      <Button
                        text={"Zatražite ponudu"}
                        variant={"primary"}
                        size={"base"}
                        width="w-full"
                      ></Button>
                    </Link>
                    {car.vehicle.type_hr.toUpperCase() === "OSOBNO VOZILO" && (
                      <>
                        <Link
                          to={`/request/${id}`}
                          state={{
                            mode: "Zatražite testnu vožnju",
                          }}
                        >
                          <Button
                            text={"Zatražite testnu vožnju"}
                            variant={"secondary"}
                            size={"base"}
                            width="w-full"
                          ></Button>
                        </Link>
                      </>
                    )}
                  </div>
                  {car.vehicle.dealer !== null && (
                    <p className="hidden sm:flex text-base items-center gap-[5px] opacity-25 text-right">
                      {car.vehicle.dealer.name}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Card>
          {car.vehicle.dealer !== null && (
            <StoreInfo dealer={car.vehicle.dealer} />
          )}
          <hr className="w-full border-t-1 border-extra-light" />

          {(car.similar_vehicles?.length > 0 ||
            car.dealer_vehicles?.length > 0) && (
              <CarouselsContainer
                similar_vehicles={
                  car.similar_vehicles?.length > 0
                    ? sortAndGroupVehicles(
                      car.similar_vehicles.filter(
                        (vehicle) =>
                          vehicle.vehicle_state_hr !== "Vozilo u dolasku"
                      )
                    ).flat()
                    : []
                }
                dealer_vehicles={
                  car.dealer_vehicles?.length > 0
                    ? sortAndGroupVehicles(
                      car.dealer_vehicles.filter(
                        (vehicle) =>
                          vehicle.vehicle_state_hr !== "Vozilo u dolasku"
                      )
                    ).flat()
                    : []
                }
              />
            )}
        </div>
      )}
    </div>
  );
};

export default CarPage;
